import React, { useEffect, useState } from "react";
import Button from "../../Common/FormElements/Button/Button";
import { useTranslation } from "react-i18next";
import Attachements from "../../Common/Forms/Attachements/Attachements";
import { documentExtensions } from "../../Produits/NewProductTabContents/data";
import API from "../../../Api/Api";
import moment from "moment/moment";
import { uploadAttachmentToStrapi } from "../../../Utils/uploadAttachmentToStrapi";
import { useDispatch, useSelector } from "react-redux";
import { transformSavedAttachGuide } from "../../Sav/SavPreview/transformSavedAttachments";
import { getDelivery, updateDelivery } from "../../../REDUX/actions/delivery";
import { Spinner } from "react-bootstrap";
import { IMAGE_END_POINT } from "../../../Api/EndPoints";
import {
  DownloadAddress,
  DownloadPackingList,
} from "../../../Utils/deliveryUtils";

const DepartureAttachments = () => {
  const { t } = useTranslation("common");
  const dispatch = useDispatch();
  const { delivery } = useSelector((state) => state.deliveryReducer);
  const { user } = useSelector((state) => state.userReducer);
  const [loading, setLoading] = useState(false);
  const [attachments, setAttachments] = useState({
    delivery: [],
    preparation: [],
  });

  const uploadAttachments = async (newAttachments) => {
    setLoading("MEDIA");
    try {
      const deliveryAttachmentIds =
        delivery?.attributes?.deliveryAttachments?.data?.map(({ id }) => id);
      const preparationAttachmentIds =
        delivery?.attributes?.preparationAttachments?.data?.map(({ id }) => id);

      let shouldUpdate = false;
      for (const attachment of newAttachments.delivery) {
        if (attachment.file instanceof File) {
          const { data: createdAttachment } = await API.post(
            "api/attachments",
            {
              data: {
                title: attachment.title,
                date: moment(attachment?.date),
              },
            },
          );
          await uploadAttachmentToStrapi(
            attachment.file,
            "depot/magasin fichier",
            createdAttachment.data.id,
            "api::attachment.attachment",
            "file",
          );

          deliveryAttachmentIds.push(createdAttachment?.data?.id);
          shouldUpdate = true;
        }
      }

      for (const attachment of newAttachments.preparation) {
        if (attachment.file instanceof File) {
          const { data: createdAttachment } = await API.post(
            "api/attachments",
            {
              data: {
                title: attachment.title,
                date: moment(attachment?.date),
              },
            },
          );
          await uploadAttachmentToStrapi(
            attachment.file,
            "depot/magasin fichier",
            createdAttachment.data.id,
            "api::attachment.attachment",
            "file",
          );
          preparationAttachmentIds.push(createdAttachment?.data?.id);
          shouldUpdate = true;
        }
      }

      if (shouldUpdate) {
        await dispatch(
          updateDelivery(
            delivery?.id,
            {
              deliveryAttachments: deliveryAttachmentIds,
              preparationAttachments: preparationAttachmentIds,
            },
            () => dispatch(getDelivery(delivery?.id)),
          ),
        );
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setAttachments((prev) => ({
      ...prev,
      delivery: transformSavedAttachGuide(
        delivery?.attributes?.deliveryAttachments?.data ?? [],
      ),
      preparation: transformSavedAttachGuide(
        delivery?.attributes?.preparationAttachments?.data || [],
      ),
    }));
  }, [delivery]);

  return (
    <div className="position-relative">
      {loading === "MEDIA" && (
        <div className="position-absolute top-0 start-0 w-100 h-100 bg-white bg-opacity-50 z-9999 d-flex align-items-center justify-content-center">
          <Spinner />
        </div>
      )}
      <div className="d-flex align-items-center gap-4 mb-4">
        <Button
          loading={loading === "LISTING"}
          onClick={async () => {
            setLoading("LISTING");
            await DownloadPackingList(
              delivery?.id,
              delivery?.attributes?.number,
              t,
            );
            setLoading(false);
          }}
        >
          <i className="bi bi-download me-2" />
          {t("Listing")}
        </Button>
        <Button
          loading={loading === "ADDRESS"}
          onClick={async () => {
            setLoading("ADDRESS");
            await DownloadAddress(
              delivery?.id,
              delivery?.attributes?.number,
              t,
            );
            setLoading(false);
          }}
        >
          <i className="bi bi-download me-2" />
          {t("Delivery Address")}
        </Button>
        <Button
          onClick={() => {
            const url =
              IMAGE_END_POINT +
              delivery?.attributes?.crm?.data?.attributes?.url;
            window.open(url, "_blank");
          }}
        >
          <i className="bi bi-download me-2" />
          {t("CRM")}
        </Button>
      </div>
      <div>
        <div className="listHeader d-flex align-items-center bg-dimGrey p-3 mt-3">
          <div className="f20 text-brightGrey mb-0 bold">
            {t("Depot")} - {t("Preparation")}
          </div>
        </div>
        <div className="mt-4 mx-n5">
          <Attachements
            canEdit={[1, 3]?.includes(user?.attributes?.userRole)}
            attachments={attachments.preparation}
            setAttachments={async (newAttachments) => {
              setAttachments({
                ...attachments,
                preparation: newAttachments,
              });
              await uploadAttachments({
                ...attachments,
                preparation: newAttachments,
              });
            }}
            acceptTypes={`image/*,video/*, ${documentExtensions.join(",")}`}
            onDelete={async () => dispatch(getDelivery(delivery?.id))}
          />
        </div>
      </div>
      <div className="mt-5">
        <div className="listHeader d-flex align-items-center bg-dimGrey p-3 mt-3">
          <div className="f20 text-brightGrey mb-0 bold">
            {t("Store")} - {t("Delivery")}
          </div>
        </div>
        <div className="mt-4 mx-n5">
          <Attachements
            canEdit={[0, 1, 2]?.includes(user?.attributes?.userRole)}
            attachments={attachments.delivery}
            setAttachments={async (newAttachments) => {
              setAttachments({
                ...attachments,
                delivery: newAttachments,
              });
              await uploadAttachments({
                ...attachments,
                delivery: newAttachments,
              });
            }}
            acceptTypes={`image/*,video/*, ${documentExtensions.join(",")}`}
          />
        </div>
      </div>
    </div>
  );
};

export default DepartureAttachments;
